import React from "react";
import styled from "styled-components";

import Logo from "components/Gui/Logo";
import PackageInfo from "components/PackageInfo/PackageInfo";

const HeaderWrapper = styled.div`
    /* width: calc(100vw - 1rem); */
    box-sizing: border-box;
    padding: 0.5rem;
    background-color: ${(props) => props.theme.LayoutBodyBackground};
    z-index: 80;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    /* position: sticky;
    top: 0; */
    /* height: 5rem; */
    border-bottom: 1px solid ${(props) => props.theme.BorderColor};
`;

const PackageInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.5rem 0 2rem 0;
`;

const NwHeaderMobile = ({ packageInfo }) => {
    return (
        <HeaderWrapper>
            <Logo />
            {packageInfo && (
                <PackageInfoWrapper>
                    <PackageInfo />
                </PackageInfoWrapper>
            )}
        </HeaderWrapper>
    );
};

export default NwHeaderMobile;
